// The Program's links by event (Seán, 2026-10-27; PROGRAM.md § 5): /2026/Program#online-workshop
// opens that event's days in the viewer's own zone. A day's key follows the zone shown (London's
// Nov 18 is Nov 19 in Sydney), so a link by dates can miss a day; a link by event can't. An event's
// days: those with its heading, as the day's title or a session's (the sheet's Category). The
// April online ("Virtual") events: not yet.

const EVENT_SESSIONS = {
  "in-person-masterclass": /^Masterclass$/i,
  "in-person-workshop": /^VIZBI Workshop$/i,
  "online-masterclass": /^Online Masterclass\b/i,
  "online-workshop": /^Online Workshop\b/i,
};

// a day token from the address ("online workshop": DayTags.vue turns "-" into " ")
const getEventName = (day) => String(day || "").trim().toLowerCase().replace(/\s+/g, "-");

export const getIsEventName = (day) => Boolean(EVENT_SESSIONS[getEventName(day)]);

// a day's headings: its title (the sheet's day row: "VIZBI Workshop") and its sessions' titles
function getHeadings(programDay) {
  const sessions = (programDay?.events || []).filter((event) => event.type === "session");
  return [programDay?.title, ...sessions.map((event) => event.title)].filter(Boolean);
}

// the event's days, as the program has them in the zone shown: ["Nov 19", "Nov 20"]
export function getEventDays(program, day) {
  const pattern = EVENT_SESSIONS[getEventName(day)];
  if (!pattern) return [];
  const isEventDay = (key) => getHeadings(program[key]).some((heading) => pattern.test(heading));
  return Object.keys(program || {}).filter(isEventDay);
}

// the program's events, for its filters (DayTags; Seán, 2026-10-29): runs of days, in schedule
// order, under one title (the sheet's day row: "Masterclass", "VIZBI Workshop", "Virtual Masterclass",
// "Online Workshop"), each its days: [["Apr 14"], ["Apr 15", "Apr 16", "Apr 17"], …]
export function getProgramEvents(program, sortedDays) {
  const events = [];
  let previousTitle = null;
  for (const day of sortedDays) {
    const title = program?.[day]?.title || "";
    if (events.length && title === previousTitle) events.at(-1).push(day);
    else events.push([day]);
    previousTitle = title;
  }
  return events;
}
